import { isMobile } from "react-device-detect";
import { className } from "../../../Utils";

import StoreSection from "../../storeSection/StoreSection.js";
import PregnancyCounter from "./PregnancyCounter.js";
import InstallNow from "../../InstallNow/InstallNow";
import { useTranslations } from "../../../lang/TranslationHooks";

import bothModules from '../assets/both-modules-phones.png'
import headerEs from '../../../assets/es/ESheader.png'
import headerEn from '../../../assets/es/ENheader.png'
import headerDe from '../../../assets/es/DEheader.png'

import whiteArrow from '../../../assets/installNowArrowWhite.png'
import './PageHeader.css'
import { useSelector } from "react-redux";

const PageHeader = ({ sections }) => {

    let { staticTranslate } = useTranslations();
    const { language } = useSelector((state) => state.home)

    const headerImages = {
        bg: {
            lang: 'bg',
            img: bothModules
        },
        de: {
            lang: 'de',
            img: headerDe
        },
        en: {
            lang: 'en',
            img: headerEn
        },
        es: {
            lang: 'es',
            img: headerEs
        }
    }

    return (
        <>
            <div className={className('pregnancy-header-container')} id={sections}>
                <div className={className(`pregnancy-header-image-container-${language}`) + ' ' + className('pregnancy-header-image-conainer')}>
                    <div className={className('pregnancy-header-information')} >
                        <div className={className(`pregnancy-wrapper`)}>
                            <div className={className('pregnancy-info-container')}>
                                <h1 data-text={staticTranslate('t_pregnancy_header_title', true)}
                                    className={className(`pregnancy-header-title-color`)}>
                                    {staticTranslate('t_pregnancy_header_title', true)}
                                </h1>

                                {
                                    language !== 'bg' &&
                                    <p className={className('pregnancy-subtitle')}>
                                        {staticTranslate('t_pregnancy_header_subtitle', true)}
                                    </p>
                                }
                            </div>
                            {isMobile &&
                                <div className={className('header-phone-images-container')}>
                                    <img src={headerImages[language]?.img} alt="both modules" />
                                </div>
                            }
                            {isMobile && <div className={className('pregnancy-header-install-now-arrow') + " " + className(`pregnancy-header-install-now-arrow-${language}`)}>

                                <div className={className(`pregnancy-header-arrow-container-${language}`)}>
                                    <img
                                        src={whiteArrow} alt="arrow"
                                        className={className('pregnancy-header-arrow')}
                                        loading="lazy"
                                    />
                                </div>
                                <div className={className('pregnancy-header-store-container')}>
                                    <StoreSection />
                                </div>
                                <InstallNow
                                    text={staticTranslate('t_pregnancy_install_free', true)}
                                    intClasName={language !== 'bg' && 'international-install-for-free'}
                                />

                            </div>}
                            {!isMobile && (
                                <div className={className('pregnancy-header-store-container')}>
                                    <StoreSection />
                                </div>
                            )}
                            {!isMobile && <>
                                <div className={className('pregnancy-header-install-now-arrow')}>
                                    <InstallNow
                                        text={staticTranslate('t_pregnancy_install_free', true)}
                                        loading='lazy'
                                    />
                                    <div className={className(`pregnancy-header-arrow-container-${language}`)}>
                                        <img
                                            src={whiteArrow} alt="arrow"
                                            className={className('pregnancy-header-arrow') + ' ' + className(language !== 'bg' && 'pregnancy-header-arrow-global')}
                                        />
                                    </div>
                                </div>
                            </>
                            }
                        </div>

                        <div className={className('header-phone-images-container')}>
                            {!isMobile
                                &&
                                <img src={headerImages[language]?.img} alt="both modules" />
                            }
                        </div>
                    </div>

                </div>
            </div >
            <div>
                <PregnancyCounter
                    title={staticTranslate('t_pregnancy_counter_title', true)}
                />
            </div>
        </>

    )
}

export default PageHeader